<template>
  <div />
</template>

<script>
import Cookie from 'js-cookie'
import { mapActions } from 'vuex'

/**
 * Vue: Country switcher (country-switcher)
 * -----------------------------------------------------------------------------
 * Switcher to let the users choose their preferred country.
 * - Static section.
 *
 * @param {String} countryIsoCode - The ISO code of the current country.
 */
export default {
  name: 'CountrySwitcher',

  props: {
    showOnLoad: {
      type: Boolean,
      default: true,
    },
    countryIsoCode: {
      type: String,
      default: '',
    },
    isRedirectEnabled: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      customerCountry: '',
      nodeSelectors: {
        close: document.querySelector('[js-country-switcher="section"] .country-switcher__overlay__close'),
        select: document.querySelector('[js-country-switcher="select"]'),
        submit: document.querySelector('[js-country-switcher="submit"]'),
      },
      sites: [
        {
          code: 'AF',
          name: 'Afghanistan',
          currency: 'EUR',
          url: 'https://int.toteme.com',
        },
        {
          code: 'AX',
          name: 'Aland Islands',
          currency: 'EUR',
          url: 'https://int.toteme.com',
        },
        {
          code: 'AL',
          name: 'Albania',
          currency: 'EUR',
          url: 'https://int.toteme.com',
        },
        {
          code: 'DZ',
          name: 'Algeria',
          currency: 'EUR',
          url: 'https://int.toteme.com',
        },
        {
          code: 'AS',
          name: 'American Samoa',
          currency: 'EUR',
          url: 'https://int.toteme.com',
        },
        {
          code: 'AD',
          name: 'Andorra',
          currency: 'EUR',
          url: 'https://int.toteme.com',
        },
        {
          code: 'AO',
          name: 'Angola',
          currency: 'EUR',
          url: 'https://int.toteme.com',
        },
        {
          code: 'AI',
          name: 'Anguilla',
          currency: 'EUR',
          url: 'https://int.toteme.com',
        },
        {
          code: 'AQ',
          name: 'Antarctica',
          currency: 'EUR',
          url: 'https://int.toteme.com',
        },
        {
          code: 'AG',
          name: 'Antigua and Barbuda',
          currency: 'EUR',
          url: 'https://int.toteme.com',
        },
        {
          code: 'AR',
          name: 'Argentina',
          currency: 'EUR',
          url: 'https://int.toteme.com',
        },
        {
          code: 'AM',
          name: 'Armenia',
          currency: 'EUR',
          url: 'https://int.toteme.com',
        },
        {
          code: 'AW',
          name: 'Aruba',
          currency: 'EUR',
          url: 'https://int.toteme.com',
        },
        {
          code: 'AU',
          name: 'Australia',
          currency: 'AUD',
          url: 'https://int.toteme.com',
        },
        {
          code: 'AT',
          name: 'Austria',
          currency: 'EUR',
          url: 'https://int.toteme.com',
        },
        {
          code: 'AZ',
          name: 'Azerbaijan',
          currency: 'EUR',
          url: 'https://int.toteme.com',
        },
        {
          code: 'BS',
          name: 'Bahamas',
          currency: 'EUR',
          url: 'https://int.toteme.com',
        },
        {
          code: 'BH',
          name: 'Bahrain',
          currency: 'EUR',
          url: 'https://int.toteme.com',
        },
        {
          code: 'BD',
          name: 'Bangladesh',
          currency: 'EUR',
          url: 'https://int.toteme.com',
        },
        {
          code: 'BB',
          name: 'Barbados',
          currency: 'EUR',
          url: 'https://int.toteme.com',
        },
        {
          code: 'BE',
          name: 'Belgium',
          currency: 'EUR',
          url: 'https://int.toteme.com',
        },
        {
          code: 'BZ',
          name: 'Belize',
          currency: 'EUR',
          url: 'https://int.toteme.com',
        },
        {
          code: 'BJ',
          name: 'Benin',
          currency: 'EUR',
          url: 'https://int.toteme.com',
        },
        {
          code: 'BM',
          name: 'Bermuda',
          currency: 'EUR',
          url: 'https://int.toteme.com',
        },
        {
          code: 'BT',
          name: 'Bhutan',
          currency: 'EUR',
          url: 'https://int.toteme.com',
        },
        {
          code: 'BO',
          name: 'Bolivia',
          currency: 'EUR',
          url: 'https://int.toteme.com',
        },
        {
          code: 'BQ',
          name: 'Bonaire, Sint Eustatius and Saba',
          currency: 'EUR',
          url: 'https://int.toteme.com',
        },
        {
          code: 'BA',
          name: 'Bosnia and Herzegovina',
          currency: 'EUR',
          url: 'https://int.toteme.com',
        },
        {
          code: 'BW',
          name: 'Botswana',
          currency: 'EUR',
          url: 'https://int.toteme.com',
        },
        {
          code: 'BR',
          name: 'Brazil',
          currency: 'EUR',
          url: 'https://int.toteme.com',
        },
        {
          code: 'IO',
          name: 'British Indian Ocean Territory',
          currency: 'EUR',
          url: 'https://int.toteme.com',
        },
        {
          code: 'BN',
          name: 'Brunei Darussalam',
          currency: 'EUR',
          url: 'https://int.toteme.com',
        },
        {
          code: 'BG',
          name: 'Bulgaria',
          currency: 'EUR',
          url: 'https://int.toteme.com',
        },
        {
          code: 'BF',
          name: 'Burkina Faso',
          currency: 'EUR',
          url: 'https://int.toteme.com',
        },
        {
          code: 'BI',
          name: 'Burundi',
          currency: 'EUR',
          url: 'https://int.toteme.com',
        },
        {
          code: 'KH',
          name: 'Cambodia',
          currency: 'EUR',
          url: 'https://int.toteme.com',
        },
        {
          code: 'CM',
          name: 'Cameroon',
          currency: 'EUR',
          url: 'https://int.toteme.com',
        },
        {
          code: 'CA',
          name: 'Canada',
          currency: 'CAD',
          url: 'https://toteme.com',
        },
        {
          code: 'CV',
          name: 'Cape Verde',
          currency: 'EUR',
          url: 'https://int.toteme.com',
        },
        {
          code: 'KY',
          name: 'Cayman Islands',
          currency: 'EUR',
          url: 'https://int.toteme.com',
        },
        {
          code: 'CF',
          name: 'Central African Republic',
          currency: 'EUR',
          url: 'https://int.toteme.com',
        },
        {
          code: 'TD',
          name: 'Chad',
          currency: 'EUR',
          url: 'https://int.toteme.com',
        },
        {
          code: 'CL',
          name: 'Chile',
          currency: 'EUR',
          url: 'https://int.toteme.com',
        },
        {
          code: 'CX',
          name: 'Christmas Island (Australia)',
          currency: 'EUR',
          url: 'https://int.toteme.com',
        },
        {
          code: 'CC',
          name: 'Cocos (Keeling) Islands',
          currency: 'EUR',
          url: 'https://int.toteme.com',
        },
        {
          code: 'CO',
          name: 'Colombia',
          currency: 'EUR',
          url: 'https://int.toteme.com',
        },
        {
          code: 'KM',
          name: 'Comoros',
          currency: 'EUR',
          url: 'https://int.toteme.com',
        },
        {
          code: 'CG',
          name: 'Congo',
          currency: 'EUR',
          url: 'https://int.toteme.com',
        },
        {
          code: 'CK',
          name: 'Cook Islands',
          currency: 'EUR',
          url: 'https://int.toteme.com',
        },
        {
          code: 'CR',
          name: 'Costa Rica',
          currency: 'EUR',
          url: 'https://int.toteme.com',
        },
        {
          code: 'CI',
          name: 'Cote d\'Ivoire',
          currency: 'EUR',
          url: 'https://int.toteme.com',
        },
        {
          code: 'HR',
          name: 'Croatia',
          currency: 'EUR',
          url: 'https://int.toteme.com',
        },
        {
          code: 'CW',
          name: 'Curacao',
          currency: 'EUR',
          url: 'https://int.toteme.com',
        },
        {
          code: 'CY',
          name: 'Cyprus',
          currency: 'EUR',
          url: 'https://int.toteme.com',
        },
        {
          code: 'CZ',
          name: 'Czech Republic',
          currency: 'EUR',
          url: 'https://int.toteme.com',
        },
        {
          code: 'CD',
          name: 'Democratic Republic of the Congo',
          currency: 'EUR',
          url: 'https://int.toteme.com',
        },
        {
          code: 'DK',
          name: 'Denmark',
          currency: 'DKK',
          url: 'https://int.toteme.com',
        },
        {
          code: 'DJ',
          name: 'Djibouti',
          currency: 'EUR',
          url: 'https://int.toteme.com',
        },
        {
          code: 'DM',
          name: 'Dominica',
          currency: 'EUR',
          url: 'https://int.toteme.com',
        },
        {
          code: 'DO',
          name: 'Dominican Republic',
          currency: 'EUR',
          url: 'https://int.toteme.com',
        },
        {
          code: 'EC',
          name: 'Ecuador',
          currency: 'EUR',
          url: 'https://int.toteme.com',
        },
        {
          code: 'EG',
          name: 'Egypt',
          currency: 'EUR',
          url: 'https://int.toteme.com',
        },
        {
          code: 'SV',
          name: 'El Salvador',
          currency: 'EUR',
          url: 'https://int.toteme.com',
        },
        {
          code: 'GQ',
          name: 'Equatorial Guinea',
          currency: 'EUR',
          url: 'https://int.toteme.com',
        },
        {
          code: 'ER',
          name: 'Eritrea',
          currency: 'EUR',
          url: 'https://int.toteme.com',
        },
        {
          code: 'EE',
          name: 'Estonia',
          currency: 'EUR',
          url: 'https://int.toteme.com',
        },
        {
          code: 'ET',
          name: 'Ethiopia',
          currency: 'EUR',
          url: 'https://int.toteme.com',
        },
        {
          code: 'FK',
          name: 'Falkland Islands (Malvinas)',
          currency: 'EUR',
          url: 'https://int.toteme.com',
        },
        {
          code: 'FO',
          name: 'Faroe Islands',
          currency: 'EUR',
          url: 'https://int.toteme.com',
        },
        {
          code: 'FJ',
          name: 'Fiji',
          currency: 'EUR',
          url: 'https://int.toteme.com',
        },
        {
          code: 'FI',
          name: 'Finland',
          currency: 'EUR',
          url: 'https://int.toteme.com',
        },
        {
          code: 'FR',
          name: 'France',
          currency: 'EUR',
          url: 'https://int.toteme.com',
        },
        {
          code: 'GF',
          name: 'French Guiana',
          currency: 'EUR',
          url: 'https://int.toteme.com',
        },
        {
          code: 'PF',
          name: 'French Polynesia',
          currency: 'EUR',
          url: 'https://int.toteme.com',
        },
        {
          code: 'TF',
          name: 'French Southern Territories',
          currency: 'EUR',
          url: 'https://int.toteme.com',
        },
        {
          code: 'GA',
          name: 'Gabon',
          currency: 'EUR',
          url: 'https://int.toteme.com',
        },
        {
          code: 'GM',
          name: 'Gambia',
          currency: 'EUR',
          url: 'https://int.toteme.com',
        },
        {
          code: 'GE',
          name: 'Georgia',
          currency: 'EUR',
          url: 'https://int.toteme.com',
        },
        {
          code: 'DE',
          name: 'Germany',
          currency: 'EUR',
          url: 'https://int.toteme.com',
        },
        {
          code: 'GH',
          name: 'Ghana',
          currency: 'EUR',
          url: 'https://int.toteme.com',
        },
        {
          code: 'GI',
          name: 'Gibraltar',
          currency: 'EUR',
          url: 'https://int.toteme.com',
        },
        {
          code: 'GR',
          name: 'Greece',
          currency: 'EUR',
          url: 'https://int.toteme.com',
        },
        {
          code: 'GL',
          name: 'Greenland',
          currency: 'EUR',
          url: 'https://int.toteme.com',
        },
        {
          code: 'GD',
          name: 'Grenada',
          currency: 'EUR',
          url: 'https://int.toteme.com',
        },
        {
          code: 'GP',
          name: 'Guadeloupe',
          currency: 'EUR',
          url: 'https://int.toteme.com',
        },
        {
          code: 'GU',
          name: 'Guam',
          currency: 'EUR',
          url: 'https://int.toteme.com',
        },
        {
          code: 'GT',
          name: 'Guatemala',
          currency: 'EUR',
          url: 'https://int.toteme.com',
        },
        {
          code: 'GN',
          name: 'Guinea',
          currency: 'EUR',
          url: 'https://int.toteme.com',
        },
        {
          code: 'GW',
          name: 'Guinea-Bissau',
          currency: 'EUR',
          url: 'https://int.toteme.com',
        },
        {
          code: 'GY',
          name: 'Guyana',
          currency: 'EUR',
          url: 'https://int.toteme.com',
        },
        {
          code: 'HT',
          name: 'Haiti',
          currency: 'EUR',
          url: 'https://int.toteme.com',
        },
        {
          code: 'VA',
          name: 'Holy See (Vatican City State)',
          currency: 'EUR',
          url: 'https://int.toteme.com',
        },
        {
          code: 'HN',
          name: 'Honduras',
          currency: 'EUR',
          url: 'https://int.toteme.com',
        },
        {
          code: 'HK',
          name: 'Hong Kong',
          currency: 'EUR',
          url: 'https://int.toteme.com',
        },
        {
          code: 'HU',
          name: 'Hungary',
          currency: 'EUR',
          url: 'https://int.toteme.com',
        },
        {
          code: 'IS',
          name: 'Iceland',
          currency: 'EUR',
          url: 'https://int.toteme.com',
        },
        {
          code: 'IN',
          name: 'India',
          currency: 'EUR',
          url: 'https://int.toteme.com',
        },
        {
          code: 'ID',
          name: 'Indonesia',
          currency: 'EUR',
          url: 'https://int.toteme.com',
        },
        {
          code: 'IQ',
          name: 'Iraq',
          currency: 'EUR',
          url: 'https://int.toteme.com',
        },
        {
          code: 'IE',
          name: 'Ireland, Republic of',
          currency: 'EUR',
          url: 'https://int.toteme.com',
        },
        {
          code: 'IL',
          name: 'Israel',
          currency: 'EUR',
          url: 'https://int.toteme.com',
        },
        {
          code: 'IT',
          name: 'Italy',
          currency: 'EUR',
          url: 'https://int.toteme.com',
        },
        {
          code: 'JM',
          name: 'Jamaica',
          currency: 'EUR',
          url: 'https://int.toteme.com',
        },
        {
          code: 'JP',
          name: 'Japan',
          currency: 'EUR',
          url: 'https://int.toteme.com',
        },
        {
          code: 'JO',
          name: 'Jordan',
          currency: 'EUR',
          url: 'https://int.toteme.com',
        },
        {
          code: 'KZ',
          name: 'Kazakhstan',
          currency: 'EUR',
          url: 'https://int.toteme.com',
        },
        {
          code: 'KE',
          name: 'Kenya',
          currency: 'EUR',
          url: 'https://int.toteme.com',
        },
        {
          code: 'KI',
          name: 'Kiribati',
          currency: 'EUR',
          url: 'https://int.toteme.com',
        },
        {
          code: 'KR',
          name: 'Korea, Republic of (South Korea)',
          currency: 'KRW',
          url: 'https://kr.toteme.com',
        },
        {
          code: 'XK',
          name: 'Kosovo',
          currency: 'EUR',
          url: 'https://int.toteme.com',
        },
        {
          code: 'KW',
          name: 'Kuwait',
          currency: 'EUR',
          url: 'https://int.toteme.com',
        },
        {
          code: 'KG',
          name: 'Kyrgyzstan',
          currency: 'EUR',
          url: 'https://int.toteme.com',
        },
        {
          code: 'LA',
          name: 'Lao People\'s Democratic Republic',
          currency: 'EUR',
          url: 'https://int.toteme.com',
        },
        {
          code: 'LV',
          name: 'Latvia',
          currency: 'EUR',
          url: 'https://int.toteme.com',
        },
        {
          code: 'LB',
          name: 'Lebanon',
          currency: 'EUR',
          url: 'https://int.toteme.com',
        },
        {
          code: 'LS',
          name: 'Lesotho',
          currency: 'EUR',
          url: 'https://int.toteme.com',
        },
        {
          code: 'LR',
          name: 'Liberia',
          currency: 'EUR',
          url: 'https://int.toteme.com',
        },
        {
          code: 'LI',
          name: 'Liechtenstein',
          currency: 'EUR',
          url: 'https://int.toteme.com',
        },
        {
          code: 'LT',
          name: 'Lithuania',
          currency: 'EUR',
          url: 'https://int.toteme.com',
        },
        {
          code: 'LU',
          name: 'Luxembourg',
          currency: 'EUR',
          url: 'https://int.toteme.com',
        },
        {
          code: 'MO',
          name: 'Macao',
          currency: 'EUR',
          url: 'https://int.toteme.com',
        },
        {
          code: 'MK',
          name: 'Macedonia, the former Yugoslav Republic of',
          currency: 'EUR',
          url: 'https://int.toteme.com',
        },
        {
          code: 'MG',
          name: 'Madagascar',
          currency: 'EUR',
          url: 'https://int.toteme.com',
        },
        {
          code: 'MW',
          name: 'Malawi',
          currency: 'EUR',
          url: 'https://int.toteme.com',
        },
        {
          code: 'MY',
          name: 'Malaysia',
          currency: 'EUR',
          url: 'https://int.toteme.com',
        },
        {
          code: 'MV',
          name: 'Maldives',
          currency: 'EUR',
          url: 'https://int.toteme.com',
        },
        {
          code: 'ML',
          name: 'Mali',
          currency: 'EUR',
          url: 'https://int.toteme.com',
        },
        {
          code: 'MT',
          name: 'Malta',
          currency: 'EUR',
          url: 'https://int.toteme.com',
        },
        {
          code: 'MH',
          name: 'Marshall Islands',
          currency: 'EUR',
          url: 'https://int.toteme.com',
        },
        {
          code: 'MQ',
          name: 'Martinique',
          currency: 'EUR',
          url: 'https://int.toteme.com',
        },
        {
          code: 'MR',
          name: 'Mauritania',
          currency: 'EUR',
          url: 'https://int.toteme.com',
        },
        {
          code: 'MU',
          name: 'Mauritius',
          currency: 'EUR',
          url: 'https://int.toteme.com',
        },
        {
          code: 'YT',
          name: 'Mayotte',
          currency: 'EUR',
          url: 'https://int.toteme.com',
        },
        {
          code: 'MX',
          name: 'Mexico',
          currency: 'EUR',
          url: 'https://int.toteme.com',
        },
        {
          code: 'FM',
          name: 'Micronesia, Federated States of',
          currency: 'EUR',
          url: 'https://int.toteme.com',
        },
        {
          code: 'MD',
          name: 'Moldova, Republic of',
          currency: 'EUR',
          url: 'https://int.toteme.com',
        },
        {
          code: 'MC',
          name: 'Monaco',
          currency: 'EUR',
          url: 'https://int.toteme.com',
        },
        {
          code: 'MN',
          name: 'Mongolia',
          currency: 'EUR',
          url: 'https://int.toteme.com',
        },
        {
          code: 'ME',
          name: 'Montenegro',
          currency: 'EUR',
          url: 'https://int.toteme.com',
        },
        {
          code: 'MS',
          name: 'Montserrat',
          currency: 'EUR',
          url: 'https://int.toteme.com',
        },
        {
          code: 'MA',
          name: 'Morocco',
          currency: 'EUR',
          url: 'https://int.toteme.com',
        },
        {
          code: 'MZ',
          name: 'Mozambique',
          currency: 'EUR',
          url: 'https://int.toteme.com',
        },
        {
          code: 'MM',
          name: 'Myanmar',
          currency: 'EUR',
          url: 'https://int.toteme.com',
        },
        {
          code: 'NA',
          name: 'Namibia',
          currency: 'EUR',
          url: 'https://int.toteme.com',
        },
        {
          code: 'NR',
          name: 'Nauru',
          currency: 'EUR',
          url: 'https://int.toteme.com',
        },
        {
          code: 'NP',
          name: 'Nepal',
          currency: 'EUR',
          url: 'https://int.toteme.com',
        },
        {
          code: 'NL',
          name: 'Netherlands',
          currency: 'EUR',
          url: 'https://int.toteme.com',
        },
        {
          code: 'NC',
          name: 'New Caledonia',
          currency: 'EUR',
          url: 'https://int.toteme.com',
        },
        {
          code: 'NZ',
          name: 'New Zealand',
          currency: 'EUR',
          url: 'https://int.toteme.com',
        },
        {
          code: 'NI',
          name: 'Nicaragua',
          currency: 'EUR',
          url: 'https://int.toteme.com',
        },
        {
          code: 'NE',
          name: 'Niger',
          currency: 'EUR',
          url: 'https://int.toteme.com',
        },
        {
          code: 'NG',
          name: 'Nigeria',
          currency: 'EUR',
          url: 'https://int.toteme.com',
        },
        {
          code: 'NU',
          name: 'Niue',
          currency: 'EUR',
          url: 'https://int.toteme.com',
        },
        {
          code: 'NF',
          name: 'Norfolk Island',
          currency: 'EUR',
          url: 'https://int.toteme.com',
        },
        {
          code: 'MP',
          name: 'Northern Mariana Islands',
          currency: 'EUR',
          url: 'https://int.toteme.com',
        },
        {
          code: 'NO',
          name: 'Norway',
          currency: 'NOK',
          url: 'https://int.toteme.com',
        },
        {
          code: 'OM',
          name: 'Oman',
          currency: 'EUR',
          url: 'https://int.toteme.com',
        },
        {
          code: 'PK',
          name: 'Pakistan',
          currency: 'EUR',
          url: 'https://int.toteme.com',
        },
        {
          code: 'PW',
          name: 'Palau',
          currency: 'EUR',
          url: 'https://int.toteme.com',
        },
        {
          code: 'PS',
          name: 'Palestine',
          currency: 'EUR',
          url: 'https://int.toteme.com',
        },
        {
          code: 'PA',
          name: 'Panama',
          currency: 'EUR',
          url: 'https://int.toteme.com',
        },
        {
          code: 'PG',
          name: 'Papua New Guinea',
          currency: 'EUR',
          url: 'https://int.toteme.com',
        },
        {
          code: 'PY',
          name: 'Paraguay',
          currency: 'EUR',
          url: 'https://int.toteme.com',
        },
        {
          code: 'PE',
          name: 'Peru',
          currency: 'EUR',
          url: 'https://int.toteme.com',
        },
        {
          code: 'PH',
          name: 'Philippines',
          currency: 'EUR',
          url: 'https://int.toteme.com',
        },
        {
          code: 'PN',
          name: 'Pitcairn',
          currency: 'EUR',
          url: 'https://int.toteme.com',
        },
        {
          code: 'PL',
          name: 'Poland',
          currency: 'EUR',
          url: 'https://int.toteme.com',
        },
        {
          code: 'PT',
          name: 'Portugal',
          currency: 'EUR',
          url: 'https://int.toteme.com',
        },
        {
          code: 'PR',
          name: 'Puerto Rico',
          currency: 'EUR',
          url: 'https://int.toteme.com',
        },
        {
          code: 'QA',
          name: 'Qatar',
          currency: 'EUR',
          url: 'https://int.toteme.com',
        },
        {
          code: 'RE',
          name: 'Reunion',
          currency: 'EUR',
          url: 'https://int.toteme.com',
        },
        {
          code: 'RO',
          name: 'Romania',
          currency: 'EUR',
          url: 'https://int.toteme.com',
        },
        {
          code: 'RW',
          name: 'Rwanda',
          currency: 'EUR',
          url: 'https://int.toteme.com',
        },
        {
          code: 'BL',
          name: 'Saint Barthelemy',
          currency: 'EUR',
          url: 'https://int.toteme.com',
        },
        {
          code: 'SH',
          name: 'Saint Helena, Ascension and Tristan da Cunha',
          currency: 'EUR',
          url: 'https://int.toteme.com',
        },
        {
          code: 'KN',
          name: 'Saint Kitts and Nevis',
          currency: 'EUR',
          url: 'https://int.toteme.com',
        },
        {
          code: 'LC',
          name: 'Saint Lucia',
          currency: 'EUR',
          url: 'https://int.toteme.com',
        },
        {
          code: 'MF',
          name: 'Saint Martin (French part)',
          currency: 'EUR',
          url: 'https://int.toteme.com',
        },
        {
          code: 'PM',
          name: 'Saint Pierre and Miquelon',
          currency: 'EUR',
          url: 'https://int.toteme.com',
        },
        {
          code: 'VC',
          name: 'Saint Vincent and the Grenadines',
          currency: 'EUR',
          url: 'https://int.toteme.com',
        },
        {
          code: 'WS',
          name: 'Samoa',
          currency: 'EUR',
          url: 'https://int.toteme.com',
        },
        {
          code: 'SM',
          name: 'San Marino',
          currency: 'EUR',
          url: 'https://int.toteme.com',
        },
        {
          code: 'ST',
          name: 'Sao Tome and Principe',
          currency: 'EUR',
          url: 'https://int.toteme.com',
        },
        {
          code: 'SA',
          name: 'Saudi Arabia',
          currency: 'EUR',
          url: 'https://int.toteme.com',
        },
        {
          code: 'SN',
          name: 'Senegal',
          currency: 'EUR',
          url: 'https://int.toteme.com',
        },
        {
          code: 'RS',
          name: 'Serbia',
          currency: 'EUR',
          url: 'https://int.toteme.com',
        },
        {
          code: 'SC',
          name: 'Seychelles',
          currency: 'EUR',
          url: 'https://int.toteme.com',
        },
        {
          code: 'SL',
          name: 'Sierra Leone',
          currency: 'EUR',
          url: 'https://int.toteme.com',
        },
        {
          code: 'SG',
          name: 'Singapore',
          currency: 'EUR',
          url: 'https://int.toteme.com',
        },
        {
          code: 'SX',
          name: 'Sint Maarten (Dutch part)',
          currency: 'EUR',
          url: 'https://int.toteme.com',
        },
        {
          code: 'SK',
          name: 'Slovakia',
          currency: 'EUR',
          url: 'https://int.toteme.com',
        },
        {
          code: 'SI',
          name: 'Slovenia',
          currency: 'EUR',
          url: 'https://int.toteme.com',
        },
        {
          code: 'SB',
          name: 'Solomon Islands',
          currency: 'EUR',
          url: 'https://int.toteme.com',
        },
        {
          code: 'ZA',
          name: 'South Africa',
          currency: 'EUR',
          url: 'https://int.toteme.com',
        },
        {
          code: 'GS',
          name: 'South Georgia and the South Sandwich Islands',
          currency: 'EUR',
          url: 'https://int.toteme.com',
        },
        {
          code: 'SS',
          name: 'South Sudan',
          currency: 'EUR',
          url: 'https://int.toteme.com',
        },
        {
          code: 'ES',
          name: 'Spain',
          currency: 'EUR',
          url: 'https://int.toteme.com',
        },
        {
          code: 'LK',
          name: 'Sri Lanka',
          currency: 'EUR',
          url: 'https://int.toteme.com',
        },
        {
          code: 'SD',
          name: 'Sudan',
          currency: 'EUR',
          url: 'https://int.toteme.com',
        },
        {
          code: 'SR',
          name: 'Suriname',
          currency: 'EUR',
          url: 'https://int.toteme.com',
        },
        {
          code: 'SJ',
          name: 'Svalbard and Jan Mayen',
          currency: 'EUR',
          url: 'https://int.toteme.com',
        },
        {
          code: 'SZ',
          name: 'Swaziland',
          currency: 'EUR',
          url: 'https://int.toteme.com',
        },
        {
          code: 'SE',
          name: 'Sweden',
          currency: 'SEK',
          url: 'https://se.toteme.com',
        },
        {
          code: 'CH',
          name: 'Switzerland',
          currency: 'EUR',
          url: 'https://int.toteme.com',
        },
        {
          code: 'TW',
          name: 'Taiwan',
          currency: 'EUR',
          url: 'https://int.toteme.com',
        },
        {
          code: 'TJ',
          name: 'Tajikistan',
          currency: 'EUR',
          url: 'https://int.toteme.com',
        },
        {
          code: 'TZ',
          name: 'Tanzania, United Republic of',
          currency: 'EUR',
          url: 'https://int.toteme.com',
        },
        {
          code: 'TH',
          name: 'Thailand',
          currency: 'EUR',
          url: 'https://int.toteme.com',
        },
        {
          code: 'TL',
          name: 'Timor-Leste',
          currency: 'EUR',
          url: 'https://int.toteme.com',
        },
        {
          code: 'TG',
          name: 'Togo',
          currency: 'EUR',
          url: 'https://int.toteme.com',
        },
        {
          code: 'TK',
          name: 'Tokelau',
          currency: 'EUR',
          url: 'https://int.toteme.com',
        },
        {
          code: 'TO',
          name: 'Tonga',
          currency: 'EUR',
          url: 'https://int.toteme.com',
        },
        {
          code: 'TT',
          name: 'Trinidad and Tobago',
          currency: 'EUR',
          url: 'https://int.toteme.com',
        },
        {
          code: 'TN',
          name: 'Tunisia',
          currency: 'EUR',
          url: 'https://int.toteme.com',
        },
        {
          code: 'TR',
          name: 'Turkey',
          currency: 'EUR',
          url: 'https://int.toteme.com',
        },
        {
          code: 'TM',
          name: 'Turkmenistan',
          currency: 'EUR',
          url: 'https://int.toteme.com',
        },
        {
          code: 'TC',
          name: 'Turks and Caicos Islands',
          currency: 'EUR',
          url: 'https://int.toteme.com',
        },
        {
          code: 'TV',
          name: 'Tuvalu',
          currency: 'EUR',
          url: 'https://int.toteme.com',
        },
        {
          code: 'UG',
          name: 'Uganda',
          currency: 'EUR',
          url: 'https://int.toteme.com',
        },
        {
          code: 'AE',
          name: 'United Arab Emirates',
          currency: 'EUR',
          url: 'https://int.toteme.com',
        },
        {
          code: 'GB',
          name: 'United Kingdom',
          currency: 'GBP',
          url: 'https://int.toteme.com',
        },
        {
          code: 'US',
          name: 'United States',
          currency: 'USD',
          url: 'https://toteme.com',
        },
        {
          code: 'UM',
          name: 'United States Minor Outlying Islands',
          currency: 'EUR',
          url: 'https://int.toteme.com',
        },
        {
          code: 'UY',
          name: 'Uruguay',
          currency: 'EUR',
          url: 'https://int.toteme.com',
        },
        {
          code: 'UZ',
          name: 'Uzbekistan',
          currency: 'EUR',
          url: 'https://int.toteme.com',
        },
        {
          code: 'VU',
          name: 'Vanuatu',
          currency: 'EUR',
          url: 'https://int.toteme.com',
        },
        {
          code: 'VN',
          name: 'Vietnam',
          currency: 'EUR',
          url: 'https://int.toteme.com',
        },
        {
          code: 'VG',
          name: 'Virgin Islands, British',
          currency: 'EUR',
          url: 'https://int.toteme.com',
        },
        {
          code: 'VI',
          name: 'Virgin Islands, U.S.',
          currency: 'EUR',
          url: 'https://int.toteme.com',
        },
        {
          code: 'WF',
          name: 'Wallis and Futuna',
          currency: 'EUR',
          url: 'https://int.toteme.com',
        },
        {
          code: 'EH',
          name: 'Western Sahara',
          currency: 'EUR',
          url: 'https://int.toteme.com',
        },
        {
          code: 'ZM',
          name: 'Zambia',
          currency: 'EUR',
          url: 'https://int.toteme.com',
        },
        {
          code: 'ZW',
          name: 'Zimbabwe',
          currency: 'EUR',
          url: 'https://int.toteme.com',
        },
      ],
    }
  },

  async mounted() {
    await this.setCustomerCountry()
    this.handleCountryPopulate()
    this.addEventListeners()

    // if toteme-selected-country cookie exists, remove it
    if (Cookie.get('toteme-selected-country')) {
      Cookie.remove('toteme-selected-country')
    }

    // Allow a user to preset the cookie and use it to manually override
    // Being redirected to a different site
    await this.handleUrlOverride()

    const cookie = this.handleCookie()

    if (cookie) {
      this.handleRedirectFromCookie(cookie)
      return
    }

    this.handleCountryCheck()

  },

  methods: {

    /**
     * Map Vuex actions.
     */
    ...mapActions({
      openOverlay: 'overlays/open',
      closeOverlay: 'overlays/close',
    }),

    /**
     * Open country switcher.
     */
    openCountrySwitcher() {
      this.openOverlay({
        component: 'country-switcher',
        ignoreDismissed: true,
        namespace: 'countrySwitcher',
      })
    },

    getSite(country) {
      return this.sites.find(site => site.code === country)
    },

    getCountryUrl(country) {
      return this.getSite(country).url + location.pathname
    },

    getRedirectUrl(country) {
      const url = new URL(country.url)

      url.searchParams.append('country', country.code)
      url.searchParams.append('curr', country.currency)
      url.searchParams.append('loc', country.code)
      url.searchParams.append('name', country.name)
      url.searchParams.append('currency', country.currency)
      return url

    },

    async setCustomerCountry() {
      const country = await this.fetchUserCountry()
      this.customerCountry = country
    },

    /**
     * Fetch user country.
     * @returns {String} - The country ISO code.
     */
    async fetchUserCountry() {
      try {
        const response = await fetch('/browsing_context_suggestions.json')
        const data = await response.json()

        return data.detected_values.country.handle
      } catch (err) {
        throw new Error(err)
      }
    },

    /**
     * Add event listeners.
     */
    addEventListeners() {
      const { close, submit } = this.nodeSelectors

      close.addEventListener('click', this.handleClose)
      submit.addEventListener('click', this.handleSubmit)
    },

    handleUrlOverride() {
      const searchParams = new URLSearchParams(window.location.search)

      if (searchParams.has('user-selected-country')) {
        const countryCode = searchParams.get('user-selected-country')
        const site = this.getSite(countryCode)

        if (site) {
          const cookie = JSON.stringify({
            country: site.code,
            name: site.name,
            currency: site.currency,
          })

          Cookie.set('user-selected-country', cookie, {
            expires: 30,
            path: '/',
            domain: 'toteme.com',
          })
        }
      }
    },

    handleCookie() {
      const cookie = Cookie.get('user-selected-country')
      try {
        return JSON.parse(cookie)
      } catch (error) {
        return null
      }
    },

    /**
     * Handle switcher close event.
     */
    handleClose() {
      this.closeOverlay('countrySwitcher')
    },

    /**
     * Handle form submission event.
     */
    handleSubmit() {
      const selectEl = this.nodeSelectors.select
      const { country, name, currency } = selectEl.options[selectEl.selectedIndex].dataset
      const countryUrl = this.getCountryUrl(country)

      const cookie = JSON.stringify({ country, name, currency })

      Cookie.set('user-selected-country', cookie, {
        expires: 30,
        path: '/',
        domain: 'toteme.com',
      })

      if (this.countryIsoCode === country) {
        this.handleClose()
        return
      }

      const newUrl = this.getRedirectUrl({
        code: country,
        name,
        currency,
        url: countryUrl,
      })

      this.handleGtm(country, name, currency, countryUrl)

      location.href = newUrl
    },

    handleGtm(country, name, currency, countryUrl) {
      const dataLayer = window.dataLayer || []

      dataLayer.push({
        event: 'country_switcher_submit',
        countrySwitcherSubmit: {
          country_code: country,
          name,
          currency,
          country_url: countryUrl,
        },
      })
    },

    /**
     * Populate country select.
     */
    handleCountryPopulate() {
      const cookie = this.handleCookie()
      const selected = cookie?.country || this.customerCountry || cnvs.store?.country

      if (this.nodeSelectors.select) {
        this.nodeSelectors.select.innerHTML = this.sites.map(site => {
          return `
          <option
            value="${site.code}"
            data-country="${site.code}"
            data-currency="${site.currency}"
            data-name="${site.name}"
            ${selected === site.code ? 'selected' : ''}
          >
            ${site.name}
          </option>
        `
        }).join('')
      } else {
        // eslint-disable-next-line no-console
        console.error('Country switcher select not found.')
      }
    },

    handleRedirectFromCookie(cookie) {
      if (Shopify?.designMode || this.showOnLoad === false) {
        return
      }

      if (cookie.country !== this.countryIsoCode) {
        const redirectUrl = this.getRedirectUrl(
          {
            code: cookie.country,
            currency: cookie.currency,
            name: cookie.name,
            url: this.getCountryUrl(cookie.country),
          },
        )

        if (redirectUrl && this.isRedirectEnabled) {
          location.href = redirectUrl
        }
      }
    },

    handleRedirectIfGeoTag() {
      const urlParams = new URLSearchParams(location.search)
      if (urlParams.get('geo') === '1') {
        location.href = this.getRedirectUrl({
          code: this.customerCountry,
          currency: this.getSite(this.customerCountry).currency,
          name: this.getSite(this.customerCountry).name,
          url: this.getCountryUrl(this.customerCountry),
        })
      }
    },

    /**
     * Check user country and current store to show the switcher accordingly.
     */
    handleCountryCheck() {
      // Skip if in theme editor
      if (Shopify?.designMode || this.showOnLoad === false) {
        return
      }

      this.handleRedirectIfGeoTag()

      const cookie = this.handleCookie()

      let redirectUrl

      if (cookie && cookie.country !== this.countryIsoCode) {
        redirectUrl = this.getRedirectUrl(
          {
            code: cookie.country,
            currency: cookie.currency,
            name: cookie.name,
            url: this.getCountryUrl(cookie.country),
          },
        )
      }

      if (!cookie && this.countryIsoCode !== this.customerCountry) {
        const site = this.getSite(this.customerCountry)

        if (!site) {
          this.openCountrySwitcher()
          return
        }

        redirectUrl = this.getRedirectUrl(site)
      }

      if (redirectUrl && this.isRedirectEnabled) {
        location.href = redirectUrl
      } else {
        this.openCountrySwitcher()
      }
    },
  },
}
</script>

<style lang="scss">
@import './country-switcher';
</style>
